import axios from 'axios';
import { API_PREFIX } from './constants';

export async function login(code: string) {
  const res = await axios.get(`${API_PREFIX.USER}/login/getUserInfo3rd`, {
    params: { code }
  });
  let corpId: string, userId: string;
  if (res && res.data) {
    const { corpInfo, userInfo } = res.data;
    ({ corpId } = corpInfo);
    ({ userId } = userInfo);
  }
  return { corpId, userId };
}

export async function makeSignature(corpId: string, agent?: boolean) {
  const res = await axios.get<{
    corpId: string;
    agentId?: string;
    timestamp: string;
    noncestr: string;
    signature: string;
  }>(`${API_PREFIX.USER}/corp/makeSignature${agent ? '?configType=agentConfig' : ''}`, {
    params: { url: window.location.href, corpId }
  });
  return {
    corpId: res.data.corpId,
    agentId: res.data.agentId,
    timestamp: res.data.timestamp,
    nonceStr: res.data.noncestr,
    signature: res.data.signature,
  };
}